var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GameBoard"},[_c('GuessList'),_c('CurrentGuess'),_c('PinOptions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }